module.exports = __webpack_public_path__ + "static/media/minbzk.763613e6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/minbzk.webp
// module id = 762
// module chunks = 0